import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { motion } from "framer-motion";
import { Shield, Award, Clock, Users } from "lucide-react";

export default function AboutSection() {
  const { t } = useLanguage();

  const stats = [
    { icon: Award, value: t.about.stats.years, label: t.about.stats.yearsLabel },
    { icon: Users, value: t.about.stats.clients, label: t.about.stats.clientsLabel },
    { icon: Clock, value: t.about.stats.response, label: t.about.stats.responseLabel },
    { icon: Shield, value: t.about.stats.available, label: t.about.stats.availableLabel },
  ];

  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-[#141311]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <span className="text-xs md:text-sm font-bold uppercase tracking-[0.2em] text-[#D4AF37]">
              {t.about.badge}
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-white mt-3 mb-6">
              {t.about.title}
            </h2>
            <p className="text-base text-[#D1D0CC] leading-relaxed mb-4">
              {t.about.text1}
            </p>
            <p className="text-base text-[#8A8881] leading-relaxed">
              {t.about.text2}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="grid grid-cols-2 gap-4"
          >
            {stats.map((stat, i) => (
              <div
                key={i}
                data-testid={`about-stat-${i}`}
                className="bg-[#1C1B18] border border-white/5 rounded-2xl p-6 text-center hover:border-[#D4AF37]/20 hover:-translate-y-1 transition-all duration-500 group"
              >
                <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/20 flex items-center justify-center group-hover:bg-[#D4AF37]/20 transition-colors duration-300">
                  <stat.icon className="w-5 h-5 text-[#D4AF37]" />
                </div>
                <p className="text-3xl lg:text-4xl font-heading font-bold text-gold-gradient">{stat.value}</p>
                <p className="text-xs text-[#8A8881] mt-2">{stat.label}</p>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
